
import { Button } from "@/components/ui/button";

const CtaSection = () => {
  return (
    <section className="py-20 px-6 md:px-12 bg-gradient-to-r from-seo-primary to-seo-secondary text-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-6">Pronto para aumentar sua presença online?</h2>
        <p className="text-xl mb-8 text-white/90">
          Não perca mais clientes para a concorrência. Apareça no Google quando seus potenciais clientes estiverem procurando.
        </p>
        <div className="flex justify-center">
          <Button 
            size="lg" 
            className="bg-white text-seo-primary hover:bg-white/90 text-lg px-8 py-6 flex items-center gap-2 transform transition-all duration-300 hover:-translate-y-1"
            onClick={() => window.open('https://wa.me/5555115197440?text=Ol%C3%A1%2C%20quero%20uma%20analise%20da%20LocalUP.', '_blank')}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
            Fale conosco no WhatsApp
          </Button>
        </div>
        <p className="mt-6 text-white/80">
          Receba um diagnóstico gratuito do seu negócio.
        </p>
      </div>
    </section>
  );
};

export default CtaSection;
